import React from "react";
import { Link } from "react-router-dom";
import { Home, ArrowLeft } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-[#051c14] text-gray-100 flex flex-col justify-between items-center p-6 text-center">
      <header className="w-full max-w-lg flex justify-between items-center py-4">
        <Link to="/" className="text-base font-bold text-white hover:text-[#34d399] transition-colors">
          Mahjong Blast
        </Link>
        <span className="font-mono text-xs text-[#34d399] bg-white/5 px-2.5 py-1 rounded-full border border-white/10">
          HTTP 404
        </span>
      </header>

      <main className="max-w-md my-auto py-12">
        <div className="text-7xl sm:text-9xl font-black font-mono tracking-tighter text-transparent bg-clip-text bg-gradient-to-br from-white via-[#34d399] to-blue-600 mb-4">
          404
        </div>
        <h1 className="text-2xl sm:text-3xl font-bold text-white mb-3">
          Page Not Found
        </h1>
        <p className="text-gray-400 text-sm mb-8 leading-relaxed">
          The route you requested does not exist or has been relocated within the Mahjong Blast web portal.
        </p>
        <div className="flex flex-wrap justify-center gap-4">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-lg font-semibold text-sm text-black bg-[#34d399] hover:opacity-90 transition-opacity shadow-lg shadow-[#34d399]/20"
          >
            <Home size={16} />
            <span>Return to Home</span>
          </Link>
        </div>
      </main>

      <footer className="py-4 text-xs text-gray-500 space-x-4">
        <Link to="/privacy" className="hover:text-gray-300">Privacy Policy</Link>
        <span>·</span>
        <Link to="/terms" className="hover:text-gray-300">Terms of Use</Link>
        <span>·</span>
        <a href="https://studio.corvas.in" target="_blank" rel="noopener noreferrer" className="hover:text-gray-300">Corvas Studio</a>
      </footer>
    </div>
  );
}
